<template>
  <footer id="footer">
    <section>
      <div class="container">
        <div class="row">
          <div class="col-sm-8">
            <div class="option__box-footer clearfix">
              <div class="pl-15">
                <div class="navbar-brand-footer pull-left">
                  <img :src="logo" target="_blank" alt="Trransfer" />
                </div>
                <!-- /.navbar-brand-footer -->
              </div>

              <!-- <ul class="region-language">
                <li>
                  <div class="dropdown">
                    <button
                      class="btn btn-default btn-language dropdown-toggle"
                      type="button"
                      id="test1"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="true"
                    >
                      <span>English</span>
                      <span class="caret"></span>
                    </button>
                  </div>
                </li>
              </ul> -->
              <!-- /.region-language -->
            </div>
          </div>
          <div class="col-sm-4 pull-right">
            <div class="right-footer">
              <div class="row text-center mt-15">
                <li class="col-sm-4">
                  <!-- <a
                    href="javascript:void(0)"
                    @click="openDisclaimer()"
                  >
                    Disclaimer
                  </a> -->
                </li>
                <li class="col-sm-4">
                  <!-- <a
                    href="javascript:void(0)"
                    @click="openPrivacyPolicy()"
                  >
                    Privacy Policy
                  </a> -->
                </li>
                <li class="col-sm-4">
                  <!-- <a href="javascript:void(0)" @click="openTermsOfUse()">Terms of Use </a> -->
                </li>
              </div>
              <!-- <div class="col-sm-4 text-right hidden">
                <a href="javascript:void(0)">Help Center</a>
              </div> -->
            </div>
          </div>
        </div>
        <div class="row">
          <p class="copyright">
            &copy;{{ thisYear }} All rights reserved. Powered by
            <a :href="productUrl" class="backlink" target="_blank">
              {{ productTitle }}
            </a>
          </p>
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container -->

      <disclaimer />
      <privacyPolicy />
      <termsOfUse />
    </section>
  </footer>
</template>

<script>
import disclaimer from "@/components/shared/Disclaimer";
import privacyPolicy from "@/components/shared/Privacy";
import termsOfUse from "@/components/shared/Terms";

export default {
  components: {
    disclaimer,
    privacyPolicy,
    termsOfUse,
  },
  computed: {
    thisYear: function () {
      return new Date().getFullYear();
    },
    cdn: function () {
      return process.env.VUE_APP_CDN;
    },
  },
  data() {
    return {
      logo: null,
      productUrl: null,
      productTitle: null,
    };
  },
  async created() {
    const publicSettings = await this.$store.dispatch("setting/getAllPublic");
    this.logo = this.$helper.extractSetting(
      publicSettings,
      "MainLogo",
      `${this.cdn}/images/logo-icon-text.png`
    );
    this.productUrl = this.$helper.extractSetting(
      publicSettings,
      "ProductUrl",
      "https://trransfer.com"
    );
    this.productTitle = this.$helper
      .extractSetting(publicSettings, "ProductTitle", "Trransfer")
      .toUpperCase();
  },
  methods: {
    openDisclaimer() {
      $("#disclaimer-modal-input").modal();
    },
    openPrivacyPolicy() {
      $("#policy-modal-input").modal();
    },
    openTermsOfUse() {
      $("#terms-modal-input").modal();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/shared/Footer.vue